module.exports = __webpack_public_path__ + "img/Z3RO_2.fbd7d53d.svg";